import { render, staticRenderFns } from "./permission.vue?vue&type=template&id=5fec5d4a&scoped=true"
import script from "./permission.vue?vue&type=script&lang=js"
export * from "./permission.vue?vue&type=script&lang=js"
import style0 from "./permission.vue?vue&type=style&index=0&id=5fec5d4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fec5d4a",
  null
  
)

export default component.exports